import React, { useEffect } from 'react';

export const ShopRedirect = () => {
  const path = window.location.pathname;
  useEffect(() => {
    window.location.href = 'https://www.tipsterchat.com' + path;
  }, []);

  return (
    <p>
      If you're not redirected automatically click
      <a href={'https://www.tipsterchat.com' + path}> here</a>;
    </p>
  );
};
